// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WadiK","index":"styles_index__3Z_h2"};